export default "__VITE_ASSET__DykNuJGm__"